import { render, staticRenderFns } from "./AddContent.vue?vue&type=template&id=213a018f&scoped=true&"
import script from "./AddContent.vue?vue&type=script&lang=js&"
export * from "./AddContent.vue?vue&type=script&lang=js&"
import style0 from "./AddContent.vue?vue&type=style&index=0&id=213a018f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213a018f",
  null
  
)

component.options.__file = "AddContent.vue"
export default component.exports